import { createActionCreator } from "deox";

import { Child } from "../../../types/models";
import { RollHttpResponse, RollOverScheduleHttpResponse } from "../../parentApi";
export const rollOverSaving = createActionCreator("rollOverSaving");
export const rollOverSavingError = createActionCreator("rollOverSavingError");
export const rollOverSaved = createActionCreator(
  "rollOverSaved",
  (resolve) => (rollOverSchedules: RollOverScheduleHttpResponse[] | null) => resolve(rollOverSchedules)
);

export const rollOverLoading = createActionCreator("rollOverLoading");
export const rollOverLoadingError = createActionCreator("rollOverLoadingError");
export const rollOverLoaded = createActionCreator(
  "rollOverLoaded",
  (resolve) => (rollOverSchedules: RollOverScheduleHttpResponse[] | null) => resolve(rollOverSchedules)
);

export const loadingRollsForChildService = createActionCreator("loadingRollsForChildService");
export const loadedRollsForChildServiceError = createActionCreator("loadedRollsForChildServiceError");
export const clearAddChildData = createActionCreator("clearAddChildData");

export const loadedRollsForChildService = createActionCreator(
  "loadedRollsForChildService",
  (resolve) => (payload: { child: Child; rollsForChild: RollHttpResponse[] | null }) => {
    return resolve(payload);
  }
);
export const rollOverInit = createActionCreator("rollOverInit");
